import { render, staticRenderFns } from "./QuestionOval.vue?vue&type=template&id=761b7f52&scoped=true"
import script from "./QuestionOval.vue?vue&type=script&lang=js"
export * from "./QuestionOval.vue?vue&type=script&lang=js"
import style0 from "./QuestionOval.vue?vue&type=style&index=0&id=761b7f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b7f52",
  null
  
)

export default component.exports